module.exports = __webpack_public_path__ + "static/media/google-play-badge-logo-svgrepo-com.07a7e181.svg";